export default Object.freeze({
    PAGE_SIZE: 10,
    CONTENT_HEADER_HEIGHT: 88,
    PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*{}[\]()\\\-_/'"`~,;:.<>])(.{10,})$/,
});
